
import axios from 'axios';
import BetterStorage from './betterStorage.service.js';
import CryptoJS from 'crypto-js';
const betterStorage = new BetterStorage();
const appId = "1f744b85f341c64d8b87e19b43174e83"
const appKey = "b529afac99550b4f93d75e7c31bbc5a8"

export async function getAccessToken() {
    let timeStamp = new Date().getTime();
    let message = appId + appKey + timeStamp;
    let hash = CryptoJS.HmacSHA1(message, appKey);
    let keyInfo = hash.toString(CryptoJS.enc.Hex)
    const res = await axios({
        url: 'https://api.xwpx.eduyun.cn/apigateway/getAccessToken',
        method: 'post',
        data: JSON.stringify({
            "timeStamp": timeStamp,
            "appId": appId,
            "keyInfo": keyInfo
        }),
        headers: {"Content-Type": "application/json; charset=utf-8"}
    });
    if(res.data.retCode==="000000"){
        return res.data.data.accessToken
    } 
    
}

